import { createSlice } from "@reduxjs/toolkit";
import { allWarehouseListAction, warhouseProductsAction } from "../asyncActions/warhouseActions";


const warhouseSlice = createSlice({
    name: 'warhouseSlice',
    initialState: {
        products: [],
        dataLoad: false,
        error: null,
        branchList: [],
        warehouseList: [],
    },
    reducers: {
     
    },
    extraReducers: (builder) => {
        builder
            .addCase(warhouseProductsAction.pending, (state) => {
                state.dataLoad = true
                state.error = null
            })
            .addCase(warhouseProductsAction.fulfilled, (state, action) => {
                state.dataLoad = false
                state.products = action.payload.map(el => ({
                    ...el.vendor_product,
                    ...el.product,
                    id: el.id,
                    quantity: el.quantity,
                    product_id: (el.vendor_product) ? el.vendor_product?.id : el.product?.id,
                    type: (el.vendor_product) ? 'VP' : 'P',
                    avg_price: el.avg_price,
                    edited: el.edited
                }))
            })
            .addCase(warhouseProductsAction.rejected, (state, action) => {
                state.dataLoad = false
                state.error = action.payload || 'error'
            })
            .addCase(allWarehouseListAction.pending, (state) => {
                state.dataLoad = true
                state.error = null
            })
            .addCase(allWarehouseListAction.fulfilled, (state, action) => {
                const {
                    warehouses,
                    branches
                } = action.payload
                state.dataLoad = false
                state.branchList = branches
                state.warehouseList = warehouses
                
            })
            .addCase(allWarehouseListAction.rejected, (state, action) => {
                state.dataLoad = false
                state.error = action.payload || 'error'
            })
    }
})

export default warhouseSlice.reducer

export const {

} = warhouseSlice.actions